<template>
  <div class="ActiveEventPanel">
    <video src="https://storage.yandexcloud.net/qubeek/Deponie_Taras_(kurz).mp4" controls></video>
    <div class="ActiveEventPanel__content" v-if="event">
      <h4 class="ActiveEventPanel__content-title">{{ event.name }}</h4>
      <div class="ActiveEventPanel__content-text">
        André Rückert, Research Associate, TU Dresden, Institute for Waste Management and Circular Economy
      </div>
      <div v-if="event.user" class="ActiveEventPanel__content-user">
        <Avatar size="sm" :src="event.user.avatar" />
        <div class="name">{{ $localized(event.user.localized_name, event.user.first_name) }} {{ $localized(event.user.localized_surname, event.user.last_name) }}</div>
      </div>
    </div>
    <MainSponsors />
  </div>
</template>

<script>
import Avatar from '@/components/user/Avatar'
import MainSponsors from '@/components/MainSponsors'
export default {
  name: 'ActiveEventPanel',
  components: { MainSponsors, Avatar },
  props: {
    event: Object,
  },
}
</script>

<style lang="scss">
.ActiveEventPanel {
  display: flex;
  flex-direction: column;
  height: 100%;

  @include PC {
    padding-top: 12px;
  }

  video {
    width: 100%;
    border: 1px solid #f2f2f2;
    border-radius: 13px;
  }

  &__content {
    margin-top: 28px;
    margin-bottom: 20px;

    &-title {
      margin-bottom: 7px;
      font-weight: 700;
      font-size: 16px;
      line-height: 117.5%;
      color: #474747;
    }

    &-text {
      font-weight: 400;
      font-size: 15px;
      line-height: 157.5%;
      color: #474747;
    }

    &-user {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .avatar {
        margin-right: 10px;
      }
    }
  }

  .main-sponsors {
    width: 100%;
    padding-top: 14px;
    margin-top: auto;
    border-top: 1px solid #f2f2f2;
    margin-bottom: 20px;
  }
}
</style>
